import React, { useEffect, useRef, useState } from 'react';
import { VideoPlayerProps } from './video-item-props';
import { classNames } from '@utilities';

const VideoPlayer: React.FC<VideoPlayerProps> = ({ selectedVideo, isMobile, onVideoComplete, onVideoStarted }) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState<boolean>(false);  
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!isIframeLoaded) return;

    const script = document.createElement('script');
    script.src = '//assets.mediadelivery.net/playerjs/player-0.1.0.min.js';
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {      
      let isStarted = false;
      const player = new playerjs.Player(iframeRef.current);
      player.on('ready', () => {
        player.on('play', () => {
            if(!isStarted) {
                onVideoStarted();
                isStarted = true;
            }            
          });
        player.on('ended', () => {                        
            onVideoComplete();
        });
      });
    };
  }, [isIframeLoaded, onVideoComplete, onVideoStarted]);

 

  return (
    <div className={classNames(
        "w-full  ",
        !isMobile ? "aspect-w-16 aspect-h-9" : "aspect-w-4 aspect-h-3"
    )}>
        {/* <SubscribePopup open={showSubscribe} onClose={() => {
          setShowSubscribe(false);
          setIsVideoCompleted(false);
        } } /> */}
      <iframe
        title="video"
        ref={iframeRef}
        src={`https://iframe.mediadelivery.net/embed/${selectedVideo?.libraryId}/${selectedVideo?.videoId}?autoplay=${false}&token=${selectedVideo?.hashValue}&expires=${
          selectedVideo?.expiry
        }`}
        loading="lazy"
        /* style={{
                        border: 'none',
                        height: '100%',
                        width: '800px',
                        borderRadius: '17px',
                      }} */
        className="w-full h-full rounded-[17px]"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen={true}
        onLoad={() => {
            setIsIframeLoaded(true);            
        }}
      ></iframe>
    </div>
  );
};

export default VideoPlayer;
